import React from 'react'

import ChevronLeft from './ChevronLeft'

const ChevronRight = props => <ChevronLeft transform='rotate(180)' {...props} />

ChevronRight.propTypes = {
  ...ChevronLeft.propTypes,
}

export default ChevronRight
